import { Page } from '@/components/layout/page/page.tsx'
import { TrackingLinksModule } from '@/modules/tracking/links/components/tracking-links-module.tsx'
import { TrackingLinksOverviewTable } from '@/modules/tracking/links/components/tracking-links-overview-table.tsx'
import type { LinkType } from '@/modules/tracking/links/types.ts'

interface TrackingLinksPageProps {
  type: LinkType
}

export const LinkTrackingPage = ({ type }: TrackingLinksPageProps) => {
  return (
    <Page className="mb-6">
      <TrackingLinksModule>
        <TrackingLinksOverviewTable type={type} />
      </TrackingLinksModule>
    </Page>
  )
}
